import React from 'react'
import { Row, Col } from 'reactstrap'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import PropTypes from 'prop-types'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import { withTranslation } from 'react-i18next'

import { processError } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import 'moment/locale/ru'
import 'moment/locale/it'
import 'moment/locale/es'
import 'moment/locale/de'
import 'moment/locale/en-gb'


const cookies = new Cookies()
const countryCode = cookies.get('countryCode')
const lang = cookies.get('i18next')

moment.locale(`${lang}-${countryCode}`)
const localizer = momentLocalizer(moment)
class Webinars extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            webinars: [],
            page: 1,
            limit: 500,
        }
        this.routeToWebinar = this.routeToWebinar.bind(this)
    }
    getWebinars(data) {
        api.getWebinars(data)
            .then((res) => {
                const events = res.map(({ start, end, ...rest }) => (
                    {
                        start: new Date(Date.parse(start)),
                        end: new Date(Date.parse(end)),
                        ...rest,
                    }))
                this.setState({ webinars: events })
            })
            .catch((e) => processError(e, this.props.history))
    }

    componentWillMount() {
        const accessToken = cookies.get('accessToken')
        this.getWebinars({ page: this.state.page, limit: this.state.limit, lang: this.props.i18n.language, token: accessToken })
    }

    routeToWebinar(event) {
        this.props.history.push(`/webinar/${event.id}`)
    }

    // Смена цвета календаря
    // eventStyleGetter(event, start, end, isSelected) {
    //     var backgroundColor = '#' + event.hexColor
    //     var style = {
    //         backgroundColor: backgroundColor,
    //         borderRadius: '0px',
    //         opacity: 0.8,
    //         color: 'black',
    //         border: '0px',
    //         display: 'block',
    //     }
    //     return { style }
    // }

    render() {
        const { t } = this.props
        return (
            <div className="content news-bg position-relative">
                <Row className="w-100 mx-0">
                    <Col xs={12} md={12} className="px-0">
                        <div className="page-title">
                            <div className="float-left">
                                <h1 className="title news-dashboard xl-font-size">{t('webinars-webinars')}</h1>
                            </div>
                        </div>

                        <div className="col-12 px-30">
                            <section className="box">
                                {/* <header className="panel_header">
                                    <div className="actions panel_actions float-right">
                                        <i className="box_toggle fa fa-chevron-down"></i>
                                        <i className="box_setting fa fa-cog"></i>
                                        <i className="box_close fa fa-times"></i>
                                    </div>
                                </header> */}
                                <div className="content-body webinar-calendar">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div style={{ height: 700, width: 100 + '%' }}>
                                                <Calendar
                                                    localizer={localizer}
                                                    events={this.state.webinars}
                                                    step={60}
                                                    defaultDate={new Date()}
                                                    onSelectEvent={(event) => this.routeToWebinar(event)}

                                                    messages={{
                                                        next: t('big-calendar-next'),
                                                        previous: t('big-calendar-previous'),
                                                        today: t('big-calendar-today'),
                                                        month: t('big-calendar-month'),
                                                        week: t('big-calendar-week'),
                                                        "work_week": t('big-calendar-work-week'),
                                                        agenda: t('big-calendar-agenda'),
                                                        day: t('big-calendar-day'),
                                                        time: t('big-calendar-time'),
                                                        event: t('big-calendar-event'),
                                                        date: t('big-calendar-date'),
                                                    }}
                                                // eventPropGetter={(this.eventStyleGetter)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

Webinars.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    history: PropTypes.object,
}

export default withTranslation()(Webinars)



// WEBPACK FOOTER //
// ./src/views/Webinars/Webinars.jsx